<template>
	<b-card no-body>
		<h4 class="mb-0 p-1 rounded-top bg-primary text-white">
			{{ title }}
			<b-badge variant="danger" class="ml-1">{{ counterSons }}</b-badge>
		</h4>
		<section v-for="(postura, indexTwo) in sons" :key="`${indexTwo}-postura`" cols="12" md="6" xl="4">
			<div style="padding: 15px 0 10px 10px" class="d-flex" :class="[indexTwo % 2 == 1 ? 'bg-posture' : '']">
				<div class="d-flex flex-column" :class="[type_evo == 'SPEC' ? 'border-spec' : '']">
					<SpecimenPlate
						style="width: 180px"
						:specimen="typeof postura.madrilla == 'string' ? postura.padrillo : postura.madrilla"
					/>
					<h6 class="text-center mt-1 font-weight-bolder">{{ postura.p_code }}</h6>
				</div>

				<div class="d-flex flex-grow-1">
					<template v-if="type_evo == 'CP'">
						<div class="d-flex align-items-center justify-content-center w-100" style="min-width: 80px">
							<h4>{{ postura[areDeads ? "dead_patas" : "eggs"] * 1 }}</h4>
						</div>
					</template>
					<template v-else-if="type_evo == 'CA'">
						<ul class="d-flex flex-wrap p-0 mb-0 align-items-center">
							<li
								v-for="(chick, indexThree) in postura[areDeads ? 'dead_chicks' : 'chicks']"
								:key="`${indexThree}-postura`"
								class="d-flex align-items-center ml-1 mb-1"
								style="min-width: 100px"
							>
								<FeatherIcon size="12" icon="ChevronsRightIcon" style="margin-right: 5px" />
								<div class="c-chick">{{ chick.correlative }}</div>
							</li>
						</ul>
					</template>
					<template v-else-if="type_evo == 'SPEC'">
						<div class="d-flex flex-wrap">
							<div
								v-for="(spec, indexFour) in postura[areDeads ? 'dead_specimens' : 'sons_specimens']"
								:key="`${indexFour}-postura`"
								class="mb-1 d-flex align-items-center"
							>
								<SpecimenPlate :specimen="spec" />
								<div class="position-relative">
									<feather-icon
										@click="openIncidenceModal(spec)"
										v-b-tooltip.hover="'Ver incidencias'"
										:class="{
											'icon-disabled': spec.incidences_qty === 0,
										}"
										class="text-primary"
										icon="AlertOctagonIcon"
										size="19"
										style="cursor: pointer"
									/>
									<span v-if="spec.incidences_qty > 0" class="incidences-counter">
										{{ spec.incidences_qty }}
									</span>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</section>
		<SpecimenIncidencesModal
			v-if="incidenceModal.show"
			:show="incidenceModal.show"
			:info="incidenceModal.info"
			@closing="incidenceModal.show = false"
		/>
	</b-card>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import SpecimenIncidencesModal from "@/views/amg/videolibrary/incidences/IncidencesModal.vue"
export default {
	name: "ShowChicksGlobalByEvo",
	components: {
		SpecimenPlate,
		SpecimenIncidencesModal,
	},
	props: {
		type_evo: {
			type: String,
			required: true,
		},
		sons: {
			type: Array,
			required: true,
		},
		areDeads: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	mounted() {
		this.make()
	},
	computed: {
		counterSons() {
			let prop = ""
			switch (this.type_evo) {
				case "CP":
					prop = this.areDeads ? "dead_patas" : "eggs"
					break
				case "CA":
					prop = this.areDeads ? "dead_chicks_count" : "chicks_all"
					break
				case "SPEC":
					prop = this.areDeads ? "dead_specimens_count" : "specimens_all"
					break
			}

			if (prop !== "") {
				return this.sons.reduce((a, b) => {
					return a + b[`${prop}`] * 1
				}, 0)
			}
			return 0
		},
	},
	data() {
		return {
			incidenceModal: {
				show: false,
				info: null,
			},
			title: "",
		}
	},
	methods: {
		openIncidenceModal(item) {
			this.incidenceModal.info = item
			this.incidenceModal.show = true
		},
		make() {
			switch (this.type_evo) {
				case "CP":
					this.title = "CINTILLO EN LA PATA"
					break
				case "CA":
					this.title = "CINTILLO EN LA ALA"
					break
				case "SPEC":
					this.title = "HIJOS EJEMPLARES"
					break
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.incidences-counter {
	position: absolute;
	top: -0.4rem;
	left: 1.3rem;
	height: 1.2rem;
	min-width: 1.2rem;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2px;
	background: var(--primary);
	border-radius: 0.2rem;
	font-weight: bolder;
	font-size: 12px;
}
.icon-disabled {
	pointer-events: none;
	opacity: 0.5;
}
.bg-posture {
	background-color: #7267f017;
}

.border-spec {
	padding-right: 20px;
	margin-right: 15px;
	border-right: 2px solid black;
	align-items: stretch !important;
}
</style>
